export default {
  'pageTitle.title': 'Examod: Digital Exam & Assessment Platform',
};
